import SvgIcon from '@ixigo/icons/SvgIcon';
import cn from '@repo/shared/utils/cn';

export const ApiFailed = (props: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<SvgIcon
			className={cn(props.className)}
			data-testid="ApiFailedIcon"
			width="375"
			height="250"
			viewBox="0 0 375 250"
			fill="none"
			{...props}
		>
			<g clip-path="url(#clip0_6716_71814)">
				<path
					d="M99.5 0H43.5V250H99.5V0Z"
					fill="url(#paint0_linear_6716_71814)"
				/>
				<path
					d="M214.371 0H158.371V250H214.371V0Z"
					fill="url(#paint1_linear_6716_71814)"
				/>
				<path
					d="M329.241 0H273.241V250H329.241V0Z"
					fill="url(#paint2_linear_6716_71814)"
				/>
				<path
					d="M325.893 159.676C328.102 159.676 329.893 161.467 329.893 163.676V174.039C329.893 176.248 328.102 178.039 325.893 178.039H304.673V258.236C304.673 260.445 302.882 262.236 300.673 262.236H290.309C288.1 262.236 286.309 260.445 286.309 258.236V178.039H87.7734V258.236C87.7734 260.445 85.9826 262.236 83.7734 262.236H73.4102C71.201 262.236 69.4102 260.445 69.4102 258.236V178.039H48.1064C45.8973 178.039 44.1064 176.248 44.1064 174.039V163.676C44.1064 161.467 45.8973 159.676 48.1064 159.676H325.893Z"
					fill="url(#paint3_linear_6716_71814)"
				/>
				<path
					d="M169.092 104.864C165.214 93.9804 169.642 81.878 179.628 76.0663L182.834 74.2004C191.339 69.2507 202.004 69.9944 209.74 76.0768L209.942 76.2353C211.009 77.0748 210.956 78.7198 209.847 79.5028C206.906 81.5778 201.062 85.7983 192.141 92.6658C183.679 99.1808 176.588 105.144 173.152 108.086C172.078 109.006 170.41 108.564 169.936 107.232L169.092 104.864Z"
					fill="#519BEC"
				/>
				<path
					d="M141.148 138.73C145.232 134.008 150.949 122.575 141.148 114.612C128.898 104.659 137.32 92.0253 141.148 91.2596C144.977 90.494 153.016 79.392 141.148 72.1184C129.281 64.8447 154.93 70.2043 157.61 65.6104C160.29 61.0165 170.626 62.9305 166.798 72.1184C162.97 81.3062 173.306 80.1577 178.665 80.9234"
					stroke="#011933"
				/>
				<rect
					x="144.007"
					y="65.0898"
					width="89.8402"
					height="6.70092"
					rx="3.35046"
					transform="rotate(90 144.007 65.0898)"
					fill="#519BEC"
				/>
				<path
					d="M131.714 142.169C131.714 137.23 135.718 133.227 140.657 133.227C145.596 133.227 149.6 137.23 149.6 142.169V143.658H131.714V142.169Z"
					fill="#519BEC"
				/>
				<path
					d="M117.702 159.672C117.702 149.53 125.924 141.309 136.066 141.309H145.248C155.39 141.309 163.612 149.53 163.612 159.672H117.702Z"
					fill="#3289E9"
				/>
				<path
					d="M127.01 153.946C124.69 147.844 129.197 141.309 135.725 141.309H146.712C156.045 141.309 163.612 148.875 163.612 158.209V158.716L128.297 154.939C127.715 154.877 127.218 154.493 127.01 153.946Z"
					fill="#519BEC"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M137.213 67.1982C137.213 62.7611 140.81 59.1641 145.248 59.1641H148.941C153.385 59.1641 157.724 60.5222 161.375 63.0566L184.737 79.2719L180.81 84.9291L157.448 68.7138C154.95 66.9797 151.982 66.0505 148.941 66.0505H145.248C144.614 66.0505 144.1 66.5643 144.1 67.1982L143.988 89.7062H137.292L137.213 67.1982Z"
					fill="#519BEC"
				/>
				<path
					d="M136.134 96.5736C136.134 96.5736 136.648 95.4937 137.338 94.3606C139.392 91.7228 142.437 91.153 143.959 89.4573C143.959 89.4573 145.11 88.3945 145.694 87.2617"
					stroke="#011933"
				/>
				<ellipse
					cx="140.657"
					cy="121.54"
					rx="1.39923"
					ry="4.14108"
					fill="#23242A"
				/>
				<path
					d="M206.736 151.984L200.227 150.625C199.135 150.397 198.44 149.32 198.684 148.232L199.436 144.861C199.674 143.794 200.726 143.116 201.797 143.339L208.36 144.709L206.736 151.984Z"
					fill="#9A7614"
				/>
				<rect
					x="202.994"
					y="151.145"
					width="1.0299"
					height="7.45399"
					transform="rotate(-167.414 202.994 151.145)"
					fill="#F6C350"
				/>
				<rect
					x="205.06"
					y="151.73"
					width="1.0299"
					height="7.45399"
					transform="rotate(-167.414 205.06 151.73)"
					fill="#F6C350"
				/>
				<path
					d="M200.938 147.457L198.736 146.965C198.244 146.855 197.934 146.368 198.044 145.876C198.154 145.384 198.642 145.074 199.134 145.184L201.336 145.676L200.938 147.457Z"
					fill="#9A7614"
				/>
				<path
					d="M236.077 153.471C234.971 158.422 236.116 159.69 226.112 159.69C221.063 159.69 218.3 159.69 212.408 159.69C210.326 157.5 207.581 152.493 208.463 148.545C209.344 144.596 212.521 141.606 216.774 140.136C219.998 139.021 223.842 138.78 227.773 139.657C236.887 141.692 237.627 146.527 236.077 153.471Z"
					fill="#F6C350"
				/>
				<path
					d="M229.488 151.525C228.289 153.983 222.642 157.206 220.087 158.877V159.691C226.451 159.691 235.291 160.247 236.152 157.347C236.286 155.536 231.765 156.592 229.488 157.347C229.988 154.382 230.688 149.067 229.488 151.525Z"
					fill="white"
				/>
				<path
					d="M252.442 150.834C251.242 153.381 245.595 156.722 243.041 158.454V159.298C249.405 159.298 256.529 159.982 259.106 156.868C259.239 154.99 254.719 156.086 252.442 156.868C252.942 153.795 253.641 148.286 252.442 150.834Z"
					fill="#F6C350"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_6716_71814"
					x1="71.5"
					y1="-48.162"
					x2="71.5"
					y2="250"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="white" stop-opacity="0" />
					<stop offset="0.578735" stop-color="#E8E8E8" stop-opacity="0.8" />
					<stop offset="1" stop-color="white" stop-opacity="0" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_6716_71814"
					x1="186.371"
					y1="-48.162"
					x2="186.371"
					y2="250"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="white" stop-opacity="0" />
					<stop offset="0.578735" stop-color="#E8E8E8" stop-opacity="0.8" />
					<stop offset="1" stop-color="white" stop-opacity="0" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_6716_71814"
					x1="301.241"
					y1="-48.162"
					x2="301.241"
					y2="250"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="white" stop-opacity="0" />
					<stop offset="0.578735" stop-color="#E8E8E8" stop-opacity="0.8" />
					<stop offset="1" stop-color="white" stop-opacity="0" />
				</linearGradient>
				<linearGradient
					id="paint3_linear_6716_71814"
					x1="187"
					y1="159.676"
					x2="187"
					y2="262.236"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="#D6D7DB" />
					<stop offset="0.693987" stop-color="#D6D7DB" stop-opacity="0" />
				</linearGradient>
				<clipPath id="clip0_6716_71814">
					<rect width="375" height="250" fill="white" />
				</clipPath>
			</defs>
		</SvgIcon>
	);
};
